// import { i18n } from '@/plugins/i18n'
// import router from '../router/index'
// import { FirebaseDynamicLinks } from 'firebase-dynamic-links';
// import axios from "axios";
import {i18n} from '@/plugins/i18n';

import {companyAddr} from '../config';
import {jsPDF} from 'jspdf';
import 'jspdf-autotable';

import '@/assets/fonts/pdf/Lato-Regular-normal.js';
import '@/assets/fonts/pdf/Lato-Bold-normal.js';
import '@/assets/fonts/pdf/Lato-Thin-normal.js';
import '@/assets/fonts/pdf/Lato-Light-normal.js';

export default {
  install(Vue) {
    const companyBase64Logo =
      'data:image/png;base64,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';

    Vue.prototype.$pdf = {
      _addDocumentPage(doc, page) {
        if (page == null) return doc;

        doc.setFont('Lato-Regular').setFontSize(9).setTextColor(0, 0, 0);
        doc.text(String(page), 197, 290);
        return doc;
      },

      _formatDocumentPage(doc) {
        doc.addImage(companyBase64Logo, 148.5, 10.5, 50, 10.27);

        // doc.setFont("Lato-Light").setFontSize(9).setTextColor(0, 0, 0);
        // doc.textWithLink(`©  ${companyAddr.name}   (${Vue.prototype.$helper.formatDate(Date.now(), false, false)})`, 20, 290, {url: companyAddr.website});

        doc.setFont('Lato-Light').setFontSize(9).setTextColor(0, 0, 0);
        doc.textWithLink(
          `Datum: ${Vue.prototype.$helper.formatDate(
            Date.now(),
            false,
            false,
          )}`,
          20,
          290,
          {url: companyAddr.website},
        );

        // doc.line(0, 87, 5, 87);
        // doc.line(0, 148.5, 5, 148.5);
        return doc;
      },

      _addDocumentTitle(doc, title) {
        if (title == null) return doc;
        doc.setFont('Lato-Bold').setFontSize(14).setTextColor(0, 0, 0);
        doc.text(title, 20, 15);
        return doc;
      },

      _addDocumentSubtitle(doc, subtitle) {
        if (subtitle == null) return doc;

        doc.setFont('Lato-Light').setFontSize(11).setTextColor(0, 0, 0);
        doc.text(subtitle, 20, 20);
        return doc;
      },

      async _getGateLogImage(imageUrl) {
        try {
          return await Vue.prototype.$helper.imageBase64(imageUrl, 'image/jpg');
        } catch {
          return;
        }
      },

      async _getVehicleLogImages(imageA, imageB) {
        try {
          const imageHandles = await Promise.all([
            Vue.prototype.$helper.imageBase64(imageA, 'image/jpg'),
            Vue.prototype.$helper.imageBase64(imageB, 'image/jpg'),
          ]);
          // console.log(imageHandles)

          return imageHandles;
        } catch {
          return;
        }
      },

      async _generateGateLogReport(doc, data, page = null, includeImages) {
        if (
          doc == null ||
          data == null ||
          data.projectName == null ||
          data.id == null
        )
          return false;
        try {
          // console.log(data)

          doc = this._formatDocumentPage(doc);

          doc = this._addDocumentTitle(
            doc,
            `${i18n.t('pdf.gatereport.title')} (${data.licensePlate})`,
          );

          doc = this._addDocumentSubtitle(doc, data.projectName);

          doc = this._addDocumentPage(doc, page);

          var startYPosition = 30;
          console.log(
            'GENERATE GATE LOG',
            includeImages,
            data.detectionImageUrl,
          );
          if (includeImages == true) {
            var imageHandle;

            for (var i = 0; i < 5; i++) {
              imageHandle = await this._getGateLogImage(data.detectionImageUrl);
              console.log(imageHandle);
              if (
                imageHandle == null ||
                !imageHandle.startsWith('data:image/jpg;base64,')
              )
                continue;
              else break;
            }

            if (!(imageHandle == null || imageHandle == false)) {
              doc.addImage(
                imageHandle,
                'JPEG',
                20,
                startYPosition,
                180,
                102,
                undefined,
                'FAST',
              );
              startYPosition = 142;
            }
          }

          doc.autoTable({
            margin: {
              left: 20,
            },

            startY: startYPosition,
            tableWidth: 180,
            styles: {font: 'Lato-Bold', textColor: 'black'},
            columnStyles: {
              0: {font: 'Lato-Regular', halign: 'start', cellWidth: 50},
            }, // Cells in first column centered and green

            // head: [['Name', 'Email', 'Country']],
            body: [
              [
                `${i18n.t('pdf.gatereport.table.licensePlate')}:`,
                data.licensePlate,
              ],
              [`${i18n.t('pdf.gatereport.table.id')}:`, String(data.id)],
              [
                `${i18n.t('pdf.gatereport.table.country')}:`,
                data.country != null
                  ? `${Vue.prototype.$helper.countryName(
                      data.country,
                    )} (${data.country.toUpperCase()})`
                  : '-',
              ],
              [`${i18n.t('pdf.gatereport.table.gate')}:`, data.gate || '-'],
              [
                `${i18n.t('pdf.gatereport.table.direction')}:`,
                data.direction != null ||
                data.direction != 1 ||
                data.direction != 2
                  ? data.direction == 1
                    ? i18n.t('pdf.gatereport.direction.entry')
                    : i18n.t('pdf.gatereport.direction.exit')
                  : '-',
              ],
              [
                `${i18n.t('pdf.gatereport.table.timestamp')}:`,
                data.timestamp != null
                  ? Vue.prototype.$helper.formatDate(data.timestamp)
                  : '-',
              ],
            ],
          });

          return doc;
        } catch (err) {
          // console.log(err)
          return false;
        }
      },

      async _generateVehicleLogReport(
        doc,
        data,
        page = null,
        includeImages = true,
      ) {
        if (
          doc == null ||
          data == null ||
          data.projectName == null ||
          data.enterGateLog == null ||
          data.exitGateLog == null ||
          data.id == null
        )
          return false;
        try {
          // console.log(data)

          doc = this._formatDocumentPage(doc);

          doc = this._addDocumentTitle(
            doc,
            `${i18n.t('pdf.vehiclelog.title')} (${
              data.enterGateLog.licensePlate
            })`,
          );

          doc = this._addDocumentSubtitle(doc, data.projectName);

          doc = this._addDocumentPage(doc, page);

          var startYPosition = 30;
          var imageHandles;

          if (includeImages == true) {
            for (var i = 0; i < 5; i++) {
              imageHandles = await this._getVehicleLogImages(
                data.enterGateLog.detectionImageUrl,
                data.exitGateLog.detectionImageUrl,
              );

              if (
                imageHandles.some(
                  (image) =>
                    image == null ||
                    !image.startsWith('data:image/jpg;base64,'),
                )
              )
                continue;
              else break;
            }

            if (
              !(
                imageHandles == null ||
                imageHandles[0] == null ||
                imageHandles[1] == null ||
                imageHandles.some((image) => image == null || image == false)
              )
            ) {
              doc.addImage(
                imageHandles[0],
                'JPEG',
                20,
                startYPosition,
                88,
                48,
                undefined,
                'FAST',
              );

              doc.setFont('Lato-Light').setFontSize(10).setTextColor(0, 0, 0);
              doc.text(
                `${i18n.t('pdf.vehiclelog.direction.entry')}:`,
                20,
                startYPosition + 53,
              );

              doc.setFont('Lato-Regular').setFontSize(10).setTextColor(0, 0, 0);
              doc.text(
                String(
                  Vue.prototype.$helper.formatDate(data.enterGateLog.timestamp),
                ),
                38,
                startYPosition + 53,
              );

              if (data.enterGateLog.gate != null) {
                doc.setFont('Lato-Light').setFontSize(10).setTextColor(0, 0, 0);
                doc.text(data.enterGateLog.gate, 38, startYPosition + 58);
              }

              doc.addImage(
                imageHandles[1],
                'JPEG',
                110,
                startYPosition,
                88,
                48,
                undefined,
                'FAST',
              );

              doc.setFont('Lato-Light').setFontSize(10).setTextColor(0, 0, 0);
              doc.text(
                `${i18n.t('pdf.vehiclelog.direction.exit')}:`,
                110,
                startYPosition + 53,
              );

              doc.setFont('Lato-Regular').setFontSize(10).setTextColor(0, 0, 0);
              doc.text(
                String(
                  Vue.prototype.$helper.formatDate(data.exitGateLog.timestamp),
                ),
                128,
                startYPosition + 53,
              );

              if (data.exitGateLog.gate != null) {
                doc.setFont('Lato-Light').setFontSize(10).setTextColor(0, 0, 0);
                doc.text(data.exitGateLog.gate, 128, startYPosition + 58);
              }

              if (
                data.whitelist != null &&
                data.whitelist.allowedTime != null
              ) {
                doc
                  .setFont('Lato-Bold')
                  .setFontSize(9)
                  .setTextColor(204, 32, 39);
                doc.text(
                  `${
                    data.whitelist.allowedTime - data.duration > 0 ? '-' : '+'
                  } ${Vue.prototype.$helper.formatDuration(
                    data.duration / 60,
                  )} h`,
                  136 +
                    doc.getTextWidth(
                      String(
                        Vue.prototype.$helper.formatDate(
                          data.exitGateLog.timestamp,
                        ),
                      ),
                    ),
                  startYPosition + 53,
                );
              }

              startYPosition = 98;
            }
          }

          doc.autoTable({
            margin: {
              left: 20,
            },

            startY: startYPosition,
            tableWidth: 180,
            styles: {font: 'Lato-Bold', textColor: 'black'},
            columnStyles: {
              0: {font: 'Lato-Regular', halign: 'start', cellWidth: 50},
            }, // Cells in first column centered and green

            // head: [['Name', 'Email', 'Country']],
            body: [
              [
                `${i18n.t('pdf.vehiclelog.table.licensePlate')}:`,
                data.enterGateLog.licensePlate,
              ],
              [`${i18n.t('pdf.vehiclelog.table.id')}:`, String(data.id)],
              [
                `${i18n.t('pdf.vehiclelog.table.country')}:`,
                data.enterGateLog.country != null &&
                Vue.prototype.$helper.countryName(data.enterGateLog.country) !=
                  null
                  ? `${Vue.prototype.$helper.countryName(
                      data.enterGateLog.country,
                    )} (${data.enterGateLog.country.toUpperCase()})`
                  : '-',
              ],
              [
                `${i18n.t('pdf.vehiclelog.table.entryGate')}:`,
                data.enterGateLog.gate || '-',
              ],
              [
                `${i18n.t('pdf.vehiclelog.table.entryTimestamp')}:`,
                data.enterGateLog.timestamp != null
                  ? Vue.prototype.$helper.formatDate(
                      data.enterGateLog.timestamp,
                    )
                  : '-',
              ],
              [
                `${i18n.t('pdf.vehiclelog.table.exitGate')}:`,
                data.exitGateLog.gate || '-',
              ],
              [
                `${i18n.t('pdf.vehiclelog.table.exitTimestamp')}:`,
                data.exitGateLog.timestamp != null
                  ? Vue.prototype.$helper.formatDate(data.exitGateLog.timestamp)
                  : '-',
              ],
              [
                `${i18n.t('pdf.vehiclelog.table.duration')}:`,
                data.duration != null
                  ? `${Vue.prototype.$helper.formatDuration(
                      data.duration / 60,
                    )} h`
                  : '-',
              ],
            ],
          });

          if (data.whitelist != null && data.whitelist.name != null) {
            doc.autoTable({
              margin: {
                left: 20,
              },
              startY: startYPosition + 70,
              tableWidth: 180,
              styles: {font: 'Lato-Bold', textColor: 'black'},
              columnStyles: {
                0: {font: 'Lato-Regular', halign: 'start', cellWidth: 50},
              }, // Cells in first column centered and green

              // head: [['Name', 'Email', 'Country']],
              body: [
                [
                  `${i18n.t('pdf.vehiclelog.table.whitelist')}:`,
                  data.whitelist.name,
                ],
                [
                  `${i18n.t('pdf.vehiclelog.table.allowedTime')}:`,
                  data.whitelist.allowedTime != null
                    ? `${Vue.prototype.$helper.formatDuration(
                        data.whitelist.allowedTime,
                      )} h`
                    : '-',
                ],
                [
                  `${i18n.t('pdf.vehiclelog.table.differenceTime')}:`,
                  data.whitelist.allowedTime != null
                    ? `${
                        data.whitelist.allowedTime - data.duration > 0
                          ? '-'
                          : '+'
                      } ${Vue.prototype.$helper.formatDuration(
                        data.whitelist.allowedTime - data.duration / 60,
                      )} h`
                    : '-',
                ],
              ],
            });
          }

          return doc;
        } catch (err) {
          // console.log(err)
          return false;
        }
      },

      async createBundleGateLog(data, includeImages) {
        if (data == null || data.data == null) return false;

        var doc = new jsPDF('p', 'mm', [297, 210]);

        for (let index = 1; index <= data.data.length; index++) {
          doc = await this._generateGateLogReport(
            doc,
            {...data.data[index - 1], projectName: data.projectName},
            index + 1,
            includeImages,
          );
          if (doc == false || doc == null) return false;
          if (index != data.data.length) doc.addPage();
        }

        doc.save(`export-${data.projectName}-log-${+new Date()}.pdf`);
        return true;
      },

      async createBundleVehicleLog(data, includeImages) {
        if (data == null || data.data == null) return false;

        var doc = new jsPDF('p', 'mm', [297, 210]);

        for (let index = 1; index <= data.data.length; index++) {
          doc = await this._generateVehicleLogReport(
            doc,
            {...data.data[index - 1], projectName: data.projectName},
            index + 1,
            includeImages,
          );
          if (doc == false || doc == null) return false;
          if (index != data.data.length) doc.addPage();
        }

        doc.save(`export-${data.projectName}-report-${+new Date()}.pdf`);
        return true;
      },
      async createVehicleLog(data) {
        var doc = new jsPDF('p', 'mm', [297, 210]);

        doc = await this._generateVehicleLogReport(doc, data);
        if (doc == false || doc == null) return false;

        doc.save(
          `export-${i18n.locale}-${data.projectName}-${
            data.enterGateLog.licensePlate
          }-report-${+new Date()}.pdf`,
        );
        return true;
      },

      async createGateLog(data, includeImages) {
        // console.log("CREATE", data)
        var doc = new jsPDF('p', 'mm', [297, 210]);

        doc = await this._generateGateLogReport(doc, data, null, includeImages);
        if (doc == false || doc == null) return false;

        doc.save(
          `export-${i18n.locale}-${data.projectName}-${
            data.licensePlate
          }-log-${+new Date()}.pdf`,
        );
        return true;
      },

      createWhitelistTable(data, vehicles) {
        if (vehicles == null || vehicles.length == 0) return false;

        var doc = new jsPDF('p', 'mm', [297, 210]);

        var plateList = [];

        vehicles.forEach((vehicle) => {
          if (
            plateList.length == 0 ||
            plateList[plateList.length - 1].length % 4 == 0
          ) {
            plateList.push([
              `${vehicle.licensePlate} (${vehicle.country.toUpperCase()})`,
            ]);
          } else {
            plateList[plateList.length - 1].push(
              `${vehicle.licensePlate} (${vehicle.country.toUpperCase()})`,
            );
          }
        });

        var tableMeta;

        doc.autoTable({
          margin: {
            left: 20,
            top: 35,
            bottom: 20,
          },

          didParseCell: (data) => {
            if (!tableMeta) {
              tableMeta = data.table;
            }
          },

          startY: 35,
          tableWidth: 180,
          styles: {font: 'Lato-Bold', textColor: 'black'},
          columnStyles: {
            0: {font: 'Lato-Regular', halign: 'start', cellWidth: 50},
          }, // Cells in first column centered and green

          body: [
            [`${i18n.t('pdf.whitelist.table.name')}:`, data.name],
            [`${i18n.t('pdf.whitelist.table.id')}:`, data.id],
            [
              `${i18n.t('pdf.whitelist.table.createdAt')}:`,
              Vue.prototype.$helper.formatDate(data.createdAt, true, false),
            ],
            [
              `${i18n.t('pdf.whitelist.table.barrier')}:`,
              data.writeToDevice == true
                ? i18n.t('pdf.whitelist.table.barrierActive')
                : '-',
            ],
            [
              `${i18n.t('pdf.whitelist.table.allowedTime')}:`,
              data.allowedTime == null
                ? '-'
                : `${Vue.prototype.$helper.formatDuration(data.allowedTime)} h`,
            ],
            [
              `${i18n.t('pdf.whitelist.table.vehicles')}:`,
              vehicles == null
                ? '-'
                : `${vehicles.length} ${i18n.t('helper.text.vehicles')}`,
            ],
          ],
        });

        doc.setFont('Lato-Bold').setFontSize(11).setTextColor(0, 0, 0);
        doc.text(
          `${i18n.t('pdf.whitelist.table.vehicles')}:`,
          20,
          tableMeta.finalY + 15,
        );
        doc.autoTable({
          margin: {
            left: 20,
            top: 35,
            bottom: 20,
          },

          startY: tableMeta.finalY + 20,
          tableWidth: 180,
          styles: {font: 'Lato-Bold', textColor: 'black'},

          body: plateList,
        });

        for (let index = 1; index <= doc.internal.getNumberOfPages(); index++) {
          doc.setPage(index);

          doc = this._formatDocumentPage(doc);

          doc = this._addDocumentTitle(doc, i18n.t('pdf.whitelist.title'));

          doc = this._addDocumentSubtitle(doc, `${data.name}`);

          doc = this._addDocumentPage(doc, index);
        }

        // doc = await this._generateGateLogReport(doc, data)
        // if (doc == false || doc == null) return false;

        doc.save(
          `export-${i18n.locale}-whitelist-${data.id}-${
            data.name
          }-${+new Date()}.pdf`,
        );
        return true;
      },
    };
  },
};
